import { BASE_SKU } from '~~/constants/extraGuaranteeSku';
import type { ProductVariant } from '~~/types/commercetools';

export const isVirtualProduct = (productSku: ProductVariant['sku']) => {

  return productSku?.startsWith(BASE_SKU);

};
